// extracted by mini-css-extract-plugin
export default {"container":"Downloads_container__HWA17","heading":"Downloads_heading__vkU3A","buttons":"Downloads_buttons__JPf-g"};